module.exports = __webpack_public_path__ + "static/media/Validation_1_Radionucléide_3.0.a97a9a90.pdf";